export interface PurchaseInvoiceHeaderDeliveryItem {
  id: string;
  purchaseInvoiceHeaderId: string;
  productId: string;
  productKey: string;
  productDescription: string;
  quantity: number;
  price: number;
  notes: string;
  deliveryValue: number;
}
